import React from 'react';
import { Badge, Table } from 'react-bootstrap';
import { ButtonTooltip, FormikNumber, Icon } from '../../../../components';

export default function EmployeeBalancesTable({ employees, setFieldValue, errors, touched, deleteEmployee }) {
  const balances = employees[0]?.balances ? employees[0]?.balances : [];
  return (
    <Table responsive size="sm">
      <thead>
        <tr>
          <th className="text-center">NOMBRE DEL TRABAJADOR</th>
          <th className="text-center">RUT</th>
          <th className="text-center">CARGO</th>
          <th className="text-center">FECHA INICIO</th>
          {balances.map((balance, index) => {
            const variant = balance.balance.balance_type === 'asset' ? 'primary' : 'danger';
            return (
              <th key={`balance-${index.toString()}`}>
                <Badge variant={variant}>{balance?.label?.toUpperCase()}</Badge>
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {employees?.map((employee, index) => {
          return employee.destroy ? null : (
            <tr key={`employee-${index.toString()}`}>
              <td className="sticky-column">{employee?.fullName}</td>
              <td className="">{employee?.nationalIdentification}</td>
              <td className="">{employee?.jobTitle?.name || employee?.jobTitle}</td>
              <td className="">{employee?.startDate}</td>
              {employee?.balances?.map((_balance, indexBalance) => {
                return (
                  <td className="text-center" key={`employee-balance-${indexBalance.toString()}`}>
                    <FormikNumber
                      abbr
                      leftAddon="$"
                      placeholder="0"
                      fieldName={`settlementGroup[employees][${index}][balances][${indexBalance}][amount]`}
                      setFieldValue={setFieldValue}
                      value={employee?.balances[indexBalance]?.amount}
                      errors={errors}
                      touched={touched}
                      margin="mb-0"
                    />
                  </td>
                );
              })}
              <td style={{ height: '10px' }}>
                <ButtonTooltip
                  onClick={() => deleteEmployee(employee)}
                  variant="circle-danger"
                  className="btn-circle"
                  size="sm"
                  text="Eliminar"
                >
                  <Icon icon="trash" />
                </ButtonTooltip>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}
